import gql from "graphql-tag";

export const GET_DASHBOARD = gql`
  query getDashboard($dateFrom: String, $dateTo: String, $countryId: String) {
    getDashboard(dateFrom: $dateFrom, dateTo: $dateTo, countryId: $countryId) {
      statusCode
      message
      data
    }
  }
`;
